module.exports = __webpack_public_path__ + "static/media/dropdown_grey.2e0117e1.png";